import { createSelector } from "reselect";
import { getActiveUsersData } from "selectors/organizations";
import Arrays from "utils/Arrays";

export const checkArchiveFetching = ({ archive: { fetchingData } }) => fetchingData;

export const getUploadingArchiveFilesCount = ({ archive: { uploadingCount } }) => uploadingCount;

export const getArchiveData = createSelector(
  [
    ({ archive: { data } }) => data,
    getActiveUsersData
  ],
  (data, users) => {
    return data.map((fileData) => {
      const { createdBy, sourceData } = fileData;

      const createdByData = createdBy && (Arrays.findById(users, createdBy) || Arrays.findByKey(users, "sub", createdBy));

      return {
        ...fileData,
        createdBy: createdByData || (sourceData && sourceData.from ? { email: sourceData.from } : null)
      };
    });
  }
);
